export default __webpack_public_path__ + "54efef2ca87a4a53869670f1f9a73070.png";